import logo from './logo.svg';
import './App.css';

import TodoCard from './My components/TodoCard';
import './index.css'
import List from './My components/List';

function App() {
  return (
    <>
    <TodoCard/>

    {/* <List/> */}
    
    </>
  )
}

export default App;
